import {css} from "@emotion/react"

import {Theme} from "../styles/theme"
import {Document} from "../../types"
import {Fragment} from "react"

type Props = Partial<Pick<Document, "downloads" | "externalDownloads">>

export const Downloads = ({downloads = [], externalDownloads = []}: Props) => {
  return (
    <div css={style}>
      <h4>Downloads</h4>
      {downloads.map((download, index) => (
        <Fragment key={index}>
          <a href={download.url} target="_blank" rel="noreferrer">
            {(download.title || download.basename).replace(/-/g, " ")}
          </a>
          <span>{download.author}</span>
        </Fragment>
      ))}
      {externalDownloads.map((download, index) => (
        <Fragment key={index}>
          <a
            href={download.destination}
            target="_blank"
            rel="noreferrer"
          >
            {download.text || baseUrl(download.destination)}
          </a>
        </Fragment>
      ))}
    </div>
  )
}

const baseUrl = (url: string) => new URL(url).host

const style = css`
  margin-bottom: 5rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 2rem rgba(106, 106, 106, 0.3);
  padding: 3rem 4rem;

  h4 {
    margin-top: 0;
  }

  a,
  span {
    display: block;
    font-weight: 300;
  }

  a:first-letter {
    text-transform: capitalize;
  }

  a:not(:first-of-type) {
    margin-top: 2rem;
  }

  span {
    font-size: 1.7rem;
    color: ${Theme.colors.fontcolors.light};
  }
`
